export class Voucher {
    readonly _id: string;
    readonly mode: string;
    readonly code: string;
    readonly onetime: boolean;
    readonly start: Date;
    readonly expiration: Date;
    readonly products: string[];
    readonly method: string;
    readonly value: number;
    readonly disabled: boolean;
    readonly usedAt: Date;
}

export class VoucherCreateDTO {
    /*** mode (manuel ou auto) */
    readonly mode: string;
    readonly code?: string;
    readonly onetime: boolean;
    readonly start: Date;
    readonly expiration: Date;
    readonly products?: string[];
    /*** méthode de calcul (numeraire ou pourcentage) */
    readonly method: string;
    readonly value: number;
    readonly disabled: boolean;
  }



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/vouchers/voucher.model.ts